<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>返金方法登録画面</h1>
<app-sgke050d-regist [hyojiCndtFlg]="false" [kinkoMno]="data.kinkoMno" [kinkoRrkno]="data.kinkoRrkno"
    [repayMno]="data.repayMno" [recptFixNo]="data.recptFixNo" [kinkoUpdateSrno]="data.kinkoUpdateSrno"
    [kinkoexUpdatesequencenumber]="data.kinkoexUpdatesequencenumber" (clickModalCloseEvent)="onClickClose()"
    (msgEmit)="showMsg($event)">
</app-sgke050d-regist>